export { IdentityDocumentSidePage } from './IdentityDocumentSidePage';
